import { Helmet } from "react-helmet-async";

const SITE_URL = "https://ghostinbox.xyz";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

export default function SeoHead({
  title,
  description,
  path = "/",
  keywords,
  noindex = false,
  jsonLd,
}) {
  const canonical = `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Ghost Inbox" />
      <meta property="og:image" content={DEFAULT_OG_IMAGE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

export const SEO_KEYWORDS =
  "temporary inbox, privacy email, software testing email, QA testing inbox, email workflow validation, verification testing, spam protection, secure temp mail, ghost inbox, developer email testing";
